module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page auth-page twitter-verify-page text-xs-center"
  }, [_vm._m(0), _vm._v(" "), (_vm.isLoading) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('v-progress-circular', {
    staticClass: "primary--text part-loading-activity",
    attrs: {
      "indeterminate": "",
      "size": 50
    }
  })], 1) : _c('h4', [_vm._v("Your account is being verified.")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-xs-center"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/images/nav_logo_primary.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ec361062","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/auth/social_verify.vue
// module id = 1864
// module chunks = 180